import { Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { toDineroOrUndefined } from "../../currency/currencyLib"
import { useMoney } from "../../currency/useMoney"

import { MenuDisplayScanQr } from "./MenuDisplayScanQr"
import {
    MENU_DISPLAY_BODY_FONT,
    MENU_DISPLAY_COLORS,
    MENU_DISPLAY_DISPLAY_FONT,
    MenuDisplayItem,
} from "./menuDisplayData"

const useStyles = makeStyles()((theme) => ({
    sidebar: {
        flexShrink: 0,
        width: "31.25em",
    },
    item: {
        padding: "2.25em 3.5em 2.25em 0",
        borderBottom: `.1875em solid ${theme.palette.tailwind.slate[200]}`,
    },
    itemName: {
        fontFamily: MENU_DISPLAY_DISPLAY_FONT,
        fontWeight: 700,
        fontSize: "2.75em",
        lineHeight: 1.4545,
        letterSpacing: 0,
        textTransform: "uppercase",
        color: MENU_DISPLAY_COLORS.darkGreen,
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        overflowWrap: "anywhere",
        wordBreak: "normal",
    },
    itemPrice: {
        fontFamily: MENU_DISPLAY_BODY_FONT,
        fontWeight: 700,
        fontSize: "1.5em",
        lineHeight: 1,
        letterSpacing: ".1em",
        textTransform: "uppercase",
        color: theme.palette.tailwind.slate[700],
    },
}))

type MenuDisplaySidebarProps = Readonly<{
    items: ReadonlyArray<MenuDisplayItem>
    menuQrUrl?: string
}>

export function MenuDisplaySidebar({ items, menuQrUrl }: MenuDisplaySidebarProps) {
    const { classes } = useStyles()
    const moneyFactory = useMoney({})

    const itemMetaLabel = (item: MenuDisplayItem): string => {
        const dineroPrice = toDineroOrUndefined(item.price)
        const priceLabel = dineroPrice && moneyFactory.format(dineroPrice)
        return [priceLabel, item.tag].filter(Boolean).join(" · ")
    }

    return (
        <Stack direction="column" className={classes.sidebar}>
            {items.map((item) => (
                <Stack key={item.id} direction="column" spacing=".375em" className={classes.item}>
                    <Typography className={classes.itemName}>{item.name}</Typography>
                    <Typography className={classes.itemPrice}>{itemMetaLabel(item)}</Typography>
                </Stack>
            ))}
            {menuQrUrl && <MenuDisplayScanQr menuQrUrl={menuQrUrl} />}
        </Stack>
    )
}
